import React from 'react'
import { Navigate } from 'react-router-dom'

const Security: React.FC<unknown> = () => {
  return <Navigate to='/console/personal/base' replace />
}

export default Security
